module.exports = __webpack_public_path__ + "res/ic_folder.d0899082e143e9987f0bfb8be495e324.png";